import { PaymentItemLine } from "./payment-item-line";
import * as React from "react";
import { CalcRequestValue } from "../../../../../application/domain/payment/calc-request";
import { MaxInvoiceItems } from "@graffer-inc/cloud-gov-core";

export const PaymentItemTable: React.FC<{
  calcRequest: CalcRequestValue;
  onChange: (v: CalcRequestValue) => void;
}> = ({ calcRequest, onChange }) => {
  return (
    <table className="table is-fullwidth">
      <thead>
        <tr>
          <th>費目</th>
          <th>金額</th>
          <th>税率</th>
          <th aria-label="削除" />
        </tr>
      </thead>
      <tbody>
        {calcRequest.items.map((v, index) => (
          <PaymentItemLine
            key={`payment-item-line-${index}`}
            item={v}
            onDelete={() => {
              onChange(calcRequest.remove(index).copy());
            }}
            onChange={(v) => {
              onChange(calcRequest.update(v, index).copy());
            }}
          />
        ))}
        <tr className="has-text-left">
          <td colSpan={4}>
            <button
              className="is-rounded button"
              disabled={calcRequest.items.length >= MaxInvoiceItems}
              onClick={() => {
                onChange(calcRequest.addItem().copy());
              }}
            >
              追加
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
